export const selectProvinces = (state) => state.provinces.provinces;

export const selectProvincesLoading = (state) => state.provinces.loading;
export const selectProvincesError = (state) => state.provinces.error;